import React from 'react';
import { Card, CardContent, CardActions, Button, Typography, Box, Divider } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
const PRIMARY_COLOR = '#7f59e5';

export default function EnterpriseCard({ renderFeaturesListForPlan, renderAdvancedAIFeatures }) {
  return (
    <Card className="childCard" style={{ width: '375px', margin: '0 10px', display: 'flex', flexDirection: 'column' }}>
      <CardContent className="innerTopContainer" sx={{ height: '260px' }}>
        <Typography
          sx={{ display: 'flex', justifyContent: 'space-between', fontWeight: 'bolder' }}
          variant="h5"
          component="h1"
        >
          API for Enterprises
        </Typography>
        <Typography sx={{ display: 'flex', justifyContent: 'flex-start', fontWeight: 600 }} variant="span">
          For companies who need to scale <br /> video creation
        </Typography>
        <Typography variant="h6" component="h2" style={{ textAlign: 'left', marginTop: '40px' }}>
          <>
            <span style={{ fontSize: '50px' }}>Custom</span>
          </>
        </Typography>
        <Typography variant="h6" component="h2" style={{ textAlign: 'left' }}>
          <>
            <span>One-time setup fee. Actual video minutes used, billed monthly.</span>
          </>
        </Typography>
      </CardContent>
      <CardContent style={{ display: 'flex', justifyContent: 'center' }}>
        <Box style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', width: '100%' }}>
          <p
            style={{
              display: 'flex',
              gap: '5px',
              fontSize: '14px',
            }}
          >
            <Box
              sx={{
                minWidth: '24px',
                minHeight: '24px',
                maxHeight: '24px',
                maxWidth: '24px',
              }}
            >
              <CheckCircleIcon sx={{ color: PRIMARY_COLOR }} />
            </Box>
            <span
              style={{
                minWidth: '20px',
              }}
            >
              <span
                style={{
                  fontSize: '18px',
                }}
              >
                <b>Custom</b> video minutes
              </span>
            </span>
          </p>
          <Divider sx={{ background: PRIMARY_COLOR, margin: '15px 0px' }} />
          <Typography
            variant="h5"
            component="h2"
            style={{
              textAlign: 'left',
              fontSize: '18px',
              fontWeight: 'bold',
              paddingTop: '20px',
              marginLeft: '12px',
            }}
          >
            INCLUDES
          </Typography>
          {renderFeaturesListForPlan('Enterprise', 'ProfessionalMonthlyLimitedUsePerUser', 'red')}
          <div style={{ marginTop: 'auto' }}>
            <CardActions style={{ display: 'flex', justifyContent: 'center' }}>
              <Button
                onClick={() => {
                  const anchor = document.createElement('a');
                  anchor.href = 'https://calendly.com/d/cpwq-qrt-3kj';
                  anchor.target = '_blank';
                  anchor.click();
                }}
                variant="contained"
                style={{
                  width: '100%',
                  background: PRIMARY_COLOR,
                  marginBottom: '12px',
                  height: '50px',
                  fontSize: '18px',
                }}
              >
                Let's Talk
              </Button>
            </CardActions>
          </div>
          <Typography
            variant="h5"
            component="h2"
            style={{ textAlign: 'left', fontSize: '18px', fontWeight: 'bold', marginLeft: '12px' }}
          >
            EVERYTHING IN API SELF-SERVE PLUS
          </Typography>
          {renderAdvancedAIFeatures('Enterprise', '', 'red')}
        </Box>
      </CardContent>
    </Card>
  );
}
